module.exports = __webpack_public_path__ + "img/img_18.9612672c.png";